<template>
  <input :type="type" :value="value" @input="input" :placeholder="placeholder" />
</template>

<script>
export default {
  name: 'e-input',
  data() {
    return {
      inputValue: '',
    }
  },
  props: {
    placeholder: String,

    type: {
      default: 'text',
    },

    value: {
      default: '',
    },
  },
  methods: {
    input() {
      this.$emit('input', event.target.value)
    },
  },
}
</script>
<style scoped>
input {
  border: 1px solid #e1e4eb;
  border-radius: 8px;
  width: 100%;
  position: relative;
  background: #fff;
  outline: 0;
  height: 38px;
  color: #6e7783;
  padding: 0 10px;
}
</style>
